import AppLayout from '@amzn/awsui-components-react-v3/polaris/app-layout';
import React, {useEffect, useState} from 'react';
import {appLayoutNavigationLabels} from 'src/common/labels';
import {ServiceNavigation} from 'src/components/navigation';
import 'src/styles/index.scss';
import {AppRoutes, BreadcrumbGroupWithRouter} from "src/components/common/router-common";
import {BreadcrumbGroupProps} from "@amzn/awsui-components-react-v3/polaris/breadcrumb-group/interfaces";
import {SwoUiMetrics} from "src/utils/swo-ui-metrics/swo-ui-metrics";
import {metricFeaturesList, metricPageNames} from "src/constants/swo-ui-metric-constants";
import {Box, Container, Header, Tiles} from "@amzn/awsui-components-react-v3";
import {TilesProps} from "@amzn/awsui-components-react-v3/polaris/tiles/interfaces";
import {BulkRedriveWorkflowInstance} from "src/components/redrive-workflow-instance/bulk-redrive-workflow-instance";

export default function RedriveWorkflowInstance() {

    const bulkRedrive: TilesProps.TilesDefinition = {
        value: 'bulk',
        label: 'Bulk Redrive',
        description:
            'Use this option to redrive multiple workflow instance using csv file.'
    }

    const items: ReadonlyArray<TilesProps.TilesDefinition> = [bulkRedrive]

    const [selectedOption, setSelectedOption] = useState<string>(bulkRedrive.value);
    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(metricFeaturesList.index, metricPageNames.redriveWorkflowInstance)
    }, [])

    const bcItems: Array<BreadcrumbGroupProps.Item> = [
        {
            "text": "Home",
            "href": AppRoutes.home
        },
        {
            "text": "Workflow Instances",
            "href": AppRoutes.executionList
        },
        {
            "text": "Redrive Workflow Instances",
            "href": "#"
        }
    ]

    return (
        <AppLayout
            navigation={<ServiceNavigation/>}
            content={<>
                <Container header={<Header variant={"h2"}>Please select</Header>}>
                    <Tiles
                        data-testid="redrive-workflow-tiles"
                        items={items}
                        value={selectedOption}
                    />
                </Container>
                {selectedOption === bulkRedrive.value && <Box><BulkRedriveWorkflowInstance/></Box>}
            </>}
            breadcrumbs={<BreadcrumbGroupWithRouter items={bcItems}/>}
            contentType="form"
            disableContentPaddings={false}
            toolsHide={true}
            ariaLabels={appLayoutNavigationLabels}
            maxContentWidth={Number.MAX_VALUE}
        />
    );
}
